$().ready(function () {
    var offset = 300;
	var duration = 300;
    $(window).scroll(function () {
        $('.go-top-btn').toggleClass('fade', $(this).scrollTop() <= offset);

        if ($(this).scrollTop() > 40) {
            $('#header').addClass('sticky');
            $('.top-band').addClass('relative');
        } else {
            $('#header').removeClass('sticky');
            $('.top-band').removeClass('relative');
        }
    });

    $('.go-top-btn').click(function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, duration);
        return false;
    })
});
